import { View, StyleSheet, Text, Pressable, FlatList } from "react-native";
import { useUISlice } from "@/models/useUISlice";
import ModalContainer from "@/ui/ModalContainer";
import { ms } from "@/ui/moderateScale";
import { useTranslation } from "react-i18next";
import { Colors } from "@/constants";
import Icon, { IconType } from "./Icon";

const AlertWidgetCreateNote = () => {
  const visible = useUISlice((state) => state.alertWidget === "createNote");
  const setVisible = useUISlice((state) => state.setAlertWidget);
  const width = useUISlice((state) => state.device.width);
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <ModalContainer
      title={t("alertWidgetCreateNote.title")}
      onDismiss={() => setVisible(undefined)}
      hideCancel
      modalWidth={Math.min(width, 600)}
    >
      <View style={styles.spacer} />

      <AlertWidgetCreateNote.ActionsList />

      <View style={styles.negativeMargin} />
    </ModalContainer>
  );
};

AlertWidgetCreateNote.ActionsList = () => {
  const width = useUISlice((state) => state.device.width);
  const isMobile = useUISlice((state) => state.device.isMobile);
  const { t } = useTranslation();

  return (
    <FlatList
      key={`${width}-${isMobile ? 1 : 2}`}
      numColumns={isMobile ? 1 : 2}
      contentContainerStyle={{ gap: ms(12), marginRight: -ms(12) }}
      style={{ marginBottom: ms(32) }}
      data={
        [
          {
            icon: "record",
            title: t("alertWidgetCreateNote.recordAudio"),
            onPress: () =>
              useUISlice.getState().setAlertWidget("voice_recording"),
          },
          {
            icon: "upload",
            title: t("alertWidgetCreateNote.uploadAudio"),
            onPress: () => useUISlice.getState().setAlertWidget("media_import"),
          },
          {
            icon: "actionCreateText",
            title: t("alertWidgetCreateNote.copyText"),
            onPress: () => useUISlice.getState().setAlertWidget("text"),
          },
          {
            icon: "actionUploadPdf",
            title: t("alertWidgetCreateNote.uploadPdfOrImage"),
            onPress: () => useUISlice.getState().setAlertWidget("pdf_import"),
          },
        ] as {
          icon: IconType;
          title: string;
          onPress: () => void;
        }[]
      }
      renderItem={({ item, index }) => (
        <Pressable style={styles.optionCard} onPress={item.onPress}>
          <View style={styles.iconContainer}>
            <Icon icon={item.icon} style={styles.icon} />
          </View>
          <Text numberOfLines={2} style={styles.optionText}>
            {item.title}
          </Text>
        </Pressable>
      )}
    />
  );
};

const styles = StyleSheet.create({
  spacer: {
    height: ms(16),
  },
  negativeMargin: {
    marginBottom: -ms(16),
  },
  optionCard: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: Colors.white,
    marginRight: ms(12),
    borderRadius: ms(16),
    paddingVertical: ms(16),
    paddingHorizontal: ms(16),
    flex: 1,
    cursor: "pointer",
  },
  iconContainer: {
    width: ms(42),
    height: ms(42),
    borderRadius: ms(21),
    backgroundColor: Colors.gray3,
    alignItems: "center",
    justifyContent: "center",
    marginRight: ms(12),
  },
  icon: {
    width: ms(20),
    height: ms(20),
  },
  optionText: {
    fontSize: ms(16),
    lineHeight: ms(20),
    fontWeight: "500",
    color: Colors.text,
  },
});

export default AlertWidgetCreateNote;
